//Reset data
export const RESET = "AUTH_USER_RESET"


//Loading
export const SET_SHOW_LOADING = "AUTH_USER_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "AUTH_USER_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "AUTH_USER_SET_MESSAGE"
export const SET_IS_SUCCESS = "AUTH_USER_SET_IS_SUCCESS"
export const SET_IS_ERROR = "AUTH_USER_SET_IS_ERROR"

export const SET_ITEMS = "AUTH_USER_SET_ITEMS"
export const SET_PERMISSIONS = "AUTH_USER_SET_PERMISSIONS"
export const SET_SHOW_MESSAGE = "AUTH_USER_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "AUTH_USER_SET_HIDE_MESSAGE"

//Data
export const SET_IS_LOGIN = "AUTH_USER_SET_IS_LOGIN"
export const SET_ID = "AUTH_USER_SET_ID"

//Modal
